export const prizeList = [
  {
    icon: require("../assets/img/bean_500.png"), // 奖品图片
    name: "奖品1", // 奖品名称
    isPrize: 1 // 该奖项是否为奖品
  },
  {
    icon: require("../assets/img/bean_five.png"),
    name: "奖品2",
    isPrize: 1
  },
  {
    icon: require("../assets/img/bean_one.png"),
    name: "奖品3",
    isPrize: 1
  },
  {
    icon: require("../assets/img/point_five.png"),
    name: "奖品4",
    isPrize: 1
  },
  {
    icon: require("../assets/img/point_ten.png"),
    name: "奖品5",
    isPrize: 1
  },
  {
    icon: require("../assets/img/bean_500.png"),
    name: "奖品6",
    isPrize: 1
  },
  {
    icon: require("../assets/img/give_up.png"),
    name: "奖品7",
    isPrize: 0
  },
  {
    icon: require("../assets/img/bean_500.png"),
    name: "奖品8",
    isPrize: 1
  }
]


// WEBPACK FOOTER //
// ./src/pages/luckDraw/config.js